import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'xp-detail-layout',
	standalone: true,
	templateUrl: './xp-detail-layout.component.html',
	styleUrls: ['./xp-detail-layout.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpDetailLayoutComponent { }
